<template>
  <v-select
          v-model="selectValue"
          :label="name"
          :items="computedItems"
          item-text="label"
          item-value="value"
          :multiple="multiple"
          :chips="multiple && chips"
          :outlined="outlined"
          :rules="rules"
          :hide-details="simple"
          :disabled="disabled"
          :dense="dense"
          :hint="hint"
          :persistent-hint="persistentHint"
          @keypress.enter="onSubmit"
          @change="onChange"
  >
    <template v-slot:item="{attrs, item}" v-if="withDescription">
      <div class="d-flex flex-row">
        <v-checkbox :value="attrs.inputValue" v-if="multiple"/>
        <div class="d-flex flex-column ma-2">
          <div>
            {{item.label[0]}}
          </div>
          <div class="body-2" style="color: #757575">
            {{item.label[1]}}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:selection="{item}" v-if="withDescription">
      <v-chip v-if="multiple">
        {{item.label[0]}}
      </v-chip>
      <template v-else>
        {{item.label[0]}}
      </template>
    </template>
  </v-select>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "SelectField",
    props: {
      "value": [Number, String, Array],
      "name": String,
      "items": Array,
      "required": Boolean,
      "max": {
        type: Number,
        default: 1
      },
      "multi": {
        type: Boolean,
      },
      "chips": {
        type: Boolean,
        default: true
      },
      "simple": Boolean,
      outlined: {
        type: Boolean,
        default: true
      },
      "hideDetails": Boolean,
      "submit": Function,
      disabled: Boolean,
      dense: {
        type: Boolean
      },
      nullable: {
        type: Boolean,
        default: false,
      },
      hint: {
        type: String,
        default: undefined,
      },
      persistentHint: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      selectValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("input", value == null || value.length === 0 ? null : value)
        }
      },
      multiple () {
        return this.max > 1 || this.multi
      },
      rules () {
        return [
          value => {
            if (this.required) {
              if (this.multi && Array.isArray(value)) {
                return value.length > 0 || this.error("required", [this.name]);
              }
              return !!value || this.error("required", [this.name]);
            }
            return true;
          },
          value => {
            if (this.max > 1) {
              if (value === null) return true // null時、下記this.errorが実行されてしまうので回避
              return value && value.length <= this.max || this.error("max", [this.max])
            }
            return true;
          }
        ]
      },
      withDescription () {
        if (this.items && this.items.length > 0) {
          return Array.isArray(this.items[0].label)
        }
        return false
      },
      computedItems() {
        const nullableItem = { label: '', value: null }
        return this.nullable ? [nullableItem, ...this.items] : this.items
      }
    },
    methods: {
      onChange (value) {
        this.$emit("change", value);
      },
      onSubmit () {
        if (this.submit) {
          this.submit()
        }
      }
    }
  }
</script>

<style lang="sass">
.v-subheader
  font-weight: bolder
  border-bottom: 1px solid rgba(0, 0, 0, 0.54)
  height: inherit
  padding-top: 8px

</style>
